import axios from 'axios';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Fallback PUBLIC web-app configs, keyed by Firebase project_id — used only
// when the backend doesn't supply a full web config via /api/site-config
// (legacy env-configured deployments). These are public browser configs
// (apiKey is restricted by Firebase authorized domains), NOT secrets.
const FIREBASE_CONFIGS = {
  'sd-edm1': {
    apiKey: 'AIzaSyCsNO2tPFcGrEvfAlc3YwsXwiXip-pWdQs',
    authDomain: 'sd-edm1.firebaseapp.com',
    projectId: 'sd-edm1',
  },
  'sd-edm2': {
    apiKey: 'AIzaSyDu4Yl5tJ6Tex8VT6DlHNzMuZNwwXx2vQU',
    authDomain: 'sd-edm2.firebaseapp.com',
    projectId: 'sd-edm2',
  },
};

const DEFAULT_PROJECT_ID = 'sd-edm2';

// Live bindings — set by initFirebase() before the app renders.
export let auth = null;
export let brandName = null; // per-site brand from the backend tenant config

// Sign-in methods the login card offers, from tenant config (/api/site-config
// `signIn`). Microsoft is opt-in per tenant (needs an Azure app registration
// in that tenant's Firebase project).
let signInMethods = ['google', 'emailLink', 'password'];
export const getSignInMethods = () => signInMethods;

export async function initFirebase() {
  let config = null;
  try {
    // Per-hostname site config: brand + Firebase web config for this tenant.
    const { data } = await axios.get('/api/site-config');
    if (data?.brandName) brandName = data.brandName;
    if (Array.isArray(data?.signIn) && data.signIn.length) signInMethods = data.signIn;
    if (data?.firebase?.apiKey) {
      config = data.firebase;
    } else if (data?.projectId && FIREBASE_CONFIGS[data.projectId]) {
      config = FIREBASE_CONFIGS[data.projectId];
    }
  } catch (err) {
    console.error('Could not fetch site config, using defaults:', err.message);
  }

  if (!config) config = FIREBASE_CONFIGS[DEFAULT_PROJECT_ID];
  console.log(`Initializing Firebase for project ${config.projectId}`);
  initializeApp(config);
  auth = getAuth();

  // Attach the signed-in user's ID token to every API request so the backend
  // can verify it. Registered once, after auth exists.
  axios.interceptors.request.use(async (reqConfig) => {
    const token = await auth.currentUser?.getIdToken();
    if (token) {
      reqConfig.headers = reqConfig.headers || {};
      reqConfig.headers.Authorization = `Bearer ${token}`;
    }
    return reqConfig;
  });

  return auth;
}
